<template>
  <div>
    <main>
      <slot />
    </main>
    <CookieBanner />
    <LazyRewards />
    <LazyFooter />
  </div>
</template>
